import { PromiseEnvelope } from '@types';

import { apiTelemedicine } from '../api';
import { FetchTranscriptData } from '../types';

export const fetchTranscript = (
  data: FetchTranscriptData,
): PromiseEnvelope<null> => apiTelemedicine.post('conference/transcript', data);
